export { FinancialAnnouncementPage as default } from '@/components/enpages/Ir/Library/FinancialAnnouncement'
